export type TestIdProps = {
  testId?: string;
  id?: string;
  name?: string;
};

export const getTestId = (props: TestIdProps): string | undefined =>
  props.testId ?? props.id ?? props.name;
